/* unplugin-vue-components disabled */import script from "./WOMarketChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./WOMarketChannel.vue?vue&type=script&setup=true&lang=js"

import "./WOMarketChannel.vue?vue&type=style&index=0&id=50dc981a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50dc981a"]])

export default __exports__